export default __webpack_public_path__ + "static/media/misscall.1c000ed9.svg";